export default [
    {
        "stylers": [
            {
                "hue": "#baf4c4"
            },
            {
                "saturation": 10
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "color": "#effefd"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/js/mapStyles.js